module.exports = __webpack_public_path__ + "static/thumb3-b09b644140780c4be28ea127e9d628e4.jpg";